import { concatMap, map, tap } from 'rxjs';
import { httpService } from '@services/http';
import { logger } from '@services/logger';
import { HttpServiceBase, RxUtils, TypeUtils } from '@utils';
import { DealerConfig } from './dealer-config.class';

export class DealerConfigService extends HttpServiceBase {
	constructor() {
		super('dealer-config');
	}

	update(entity: Partial<DealerConfig>) {
		return httpService.patch<DealerConfig>(this.getUrl(), ``, { body: entity }).pipe(
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((result) => TypeUtils.convert(DealerConfig, result)),
			tap((result) => logger.debug(`[${this.constructor.name}.${this.update.name}]`, result))
		);
	}

	find() {
		return httpService.get<DealerConfig>(this.getUrl()).pipe(
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((result) => TypeUtils.convert(DealerConfig, result)),
			tap((result) => logger.debug(`[${this.constructor.name}.${this.find.name}]`, result))
		);
	}
}

export const dealerConfigService = new DealerConfigService();
